import { useEffect, useState } from "react";
import { DashboardLayout } from "@/components/DashboardLayout";
import { adminNav } from "@/config/nav";
import api from "@/lib/api";
import { Spinner } from "@/components/Loaders";
import { Gauge } from "@phosphor-icons/react";

const WINDOWS = [{ k: "today", l: "Today" }, { k: "tomorrow", l: "Tomorrow" }, { k: "7d", l: "Next 7 Days" }, { k: "30d", l: "Next 30 Days" }];

const Stat = ({ label, value, accent }) => (
  <div className="rounded-2xl border border-stone-200 bg-white p-4"><p className={`font-heading text-2xl font-bold ${accent || "text-stone-900"}`}>{value}</p><p className="text-xs text-stone-400">{label}</p></div>
);

export default function AdminOperations() {
  const [d, setD] = useState(null);
  const [win, setWin] = useState("7d");
  const [events, setEvents] = useState([]);
  const [report, setReport] = useState(null);

  useEffect(() => {
    api.get("/admin/operations").then((r) => setD(r.data)).catch(() => {});
    api.get("/admin/operations/report").then((r) => setReport(r.data)).catch(() => {});
  }, []);
  useEffect(() => { api.get("/admin/operations/upcoming", { params: { window: win } }).then((r) => setEvents(r.data.events)).catch(() => {}); }, [win]);

  if (!d) return <DashboardLayout nav={adminNav} title="Admin"><div className="flex justify-center py-24"><Spinner /></div></DashboardLayout>;
  return (
    <DashboardLayout nav={adminNav} title="Admin">
      <div className="flex items-center gap-2"><Gauge size={26} className="text-primary" /><h1 className="font-heading text-2xl font-semibold text-stone-900 md:text-3xl">Operations Dashboard</h1></div>
      <div className="mt-4 grid grid-cols-2 gap-3 md:grid-cols-3 lg:grid-cols-4" data-testid="ops-stats">
        <Stat label="Today's bookings" value={d.todays_bookings} />
        <Stat label="Pending requests" value={d.pending_requests} accent="text-amber-600" />
        <Stat label="Upcoming events" value={d.upcoming_events} />
        <Stat label="Payment issues" value={d.payment_issues} accent="text-red-600" />
        <Stat label="Refunds pending" value={d.refunds_pending} accent="text-red-600" />
        <Stat label="Payouts pending" value={d.payouts_pending} accent="text-amber-600" />
        <Stat label="Disputes open" value={d.disputes_open} accent="text-red-600" />
        <Stat label="Support open" value={d.support_open} accent="text-blue-600" />
      </div>

      <h2 className="mt-8 font-heading text-lg font-semibold text-stone-900">Upcoming Events</h2>
      <div className="mt-3 flex flex-wrap gap-2">
        {WINDOWS.map((w) => <button key={w.k} data-testid={`ops-window-${w.k}`} onClick={() => setWin(w.k)} className={`rounded-full px-3 py-1.5 text-sm font-medium ${win === w.k ? "bg-primary text-white" : "border border-stone-200 text-stone-600 hover:bg-accent"}`}>{w.l}</button>)}
      </div>
      <div className="mt-3 overflow-x-auto rounded-2xl border border-stone-200 bg-white">
        <table className="w-full text-sm" data-testid="ops-events-table">
          <thead className="bg-stone-50 text-left text-xs text-stone-500"><tr><th className="p-3">Booking</th><th className="p-3">Property</th><th className="p-3">Owner</th><th className="p-3">Customer</th><th className="p-3">Date</th><th className="p-3">Guests</th><th className="p-3">Status</th></tr></thead>
          <tbody>
            {events.length === 0 ? <tr><td colSpan={7} className="p-6 text-center text-stone-400">No events in this window.</td></tr> :
              events.map((e, i) => (
                <tr key={i} className="border-t border-stone-100">
                  <td className="p-3 font-medium text-stone-800">{e.booking_ref}</td><td className="p-3 text-stone-600">{e.property_name}</td>
                  <td className="p-3 text-stone-500">{e.owner_name}</td><td className="p-3 text-stone-500">{e.customer_name}</td>
                  <td className="p-3">{e.date}</td><td className="p-3">{e.guests}</td>
                  <td className="p-3"><span className="rounded-full bg-stone-100 px-2 py-0.5 text-xs">{e.booking_status}</span></td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>

      {report && (
        <>
          <h2 className="mt-8 font-heading text-lg font-semibold text-stone-900">Operations Report (this month)</h2>
          <div className="mt-3 grid grid-cols-2 gap-3 md:grid-cols-4" data-testid="ops-report">
            <Stat label="Bookings" value={report.bookings} /><Stat label="Cancellations" value={report.cancellations} />
            <Stat label="Refunds" value={report.refunds} /><Stat label="Payment failures" value={report.payment_failures} />
            <Stat label="Disputes" value={report.disputes} /><Stat label="Payout failures" value={report.payout_failures} />
            <Stat label="Support tickets" value={report.support_tickets} />
          </div>
        </>
      )}
    </DashboardLayout>
  );
}
